import pica from "pica";

async function ResizeAndCompressWithPica(file, maxWidth = 1920, quality = 0.8) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = async () => {
      try {
        let width = img.width;
        let height = img.height;

        // حساب الأبعاد الجديدة مع الحفاظ على نسبة الصورة
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const offScreenCanvas = document.createElement("canvas");
        offScreenCanvas.width = img.width;
        offScreenCanvas.height = img.height;

        const ctx = offScreenCanvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        // استخدام pica لعمل resize عالي الجودة
        const p = pica();
        await p.resize(offScreenCanvas, canvas);
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const compressedFile = new File(
                [blob],
                file.name.replace(/\.\w+$/, ".jpg"),
                { type: "image/jpeg" }
              );
              resolve(compressedFile);
            } else {
              reject(new Error("Compression failed"));
            }
          },
          "image/jpeg",
          quality // التحكم في الجودة 0.0 - 1.0
        );
      } catch (err) {
        reject(err);
      }
    };

    img.onerror = () => reject(new Error("Image decoding failed"));

    const reader = new FileReader();
    reader.onload = (e) => (img.src = e.target.result);
    reader.onerror = () => reject(reader.error || new Error("Image reading failed"));
    reader.readAsDataURL(file);
  });
}

export default ResizeAndCompressWithPica;
